<template>
  <div :class="$style.base">
    <PageWrap
      :centeredLeft="$screen !== 's'"
      smallPadding
    >
      <template #left>
        <transition
          name="fade-slide"
          appear
        >
          <BaseHeading size="xl">
            {{ $t('booking_widget.banner.title') }}
          </BaseHeading>
        </transition>
        <transition
          name="fade-slide-2"
          appear
        >
          <BaseText>{{ $t('booking_widget.banner.description') }}</BaseText>
        </transition>
        <transition
          name="fade-slide-3"
          appear
        >
          <Flex
            v-if="$screen === 's'"
            direction="column"
            :gap="0.5"
            :class="$style.widgetUrlCard"
          >
            <BaseText bold>
              {{ $t('booking_widget.banner.link_label') }}
            </BaseText>
            <BaseCard>
              <BaseText
                color="secondary"
                v-test="'booking-widget-url'"
              >
                {{ widgetUrl }}
              </BaseText>
            </BaseCard>
            <BookingQrCode
              :url="widgetUrl"
              plain
            />
            <SettingsLink v-if="hasFeatureFlag('admin-settings-bookings')" />
          </Flex>
          <Flex
            v-else
            direction="column"
          >
            <BaseText bold>
              {{ $t('booking_widget.banner.link_label') }}
            </BaseText>
            <BaseCodeField
              :code="widgetUrl"
              :loading="loadingMicroSite"
              multiline
              v-test="'booking-widget-copy-link'"
            />
            <BookingQrCode
              :url="widgetUrl"
              plain
            />
            <SettingsLink v-if="hasFeatureFlag('admin-settings-bookings')" />
          </Flex>
        </transition>
      </template>
      <template #cta>
        <BaseCopyButton
          v-if="$screen === 's'"
          :disabled="loadingMicroSite"
          :value="widgetUrl"
          v-test="'booking-widget-copy-link'"
        />
      </template>
      <template #links>
        <BaseText
          v-if="$screen === 's'"
          @click="onPreviewWidgetClick"
          v-test="'booking-widget-preview-widget'"
        >
          {{ $t('booking_widget.banner.secondary_action') }}
        </BaseText>
      </template>
      <template #right>
        <transition
          name="fade-slide-3"
          appear
        >
          <WidgetIFrame v-if="$screen !== 's'" />
        </transition>
      </template>
    </PageWrap>
    <WidgetIFrame
      v-if="$screen === 's' && showMobilePreview"
      :showMobilePreview="showMobilePreview"
      @closed="showMobilePreview = false"
    />
  </div>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import BookingQrCode from '@/modules/_shared/BookingQrCode.vue';
import PageWrap from '@/modules/online/PageWrap.vue';
import { useMicroSiteStore } from '@/stores/micro-site';
import { useUserStore } from '@/stores/user';
import SettingsLink from './SettingsLink.vue';
import WidgetIFrame from './WidgetIFrame.vue';

const { hasFeatureFlag } = useUserStore();

const { bookingWidgetUrl: widgetUrl, loading: loadingMicroSite } = storeToRefs(
  useMicroSiteStore(),
);
const showMobilePreview = ref(false);

const onPreviewWidgetClick = () => {
  showMobilePreview.value = true;
};
</script>

<style
  lang="scss"
  module
>
.base {
  height: 100%;
}
.widgetUrlCard {
  text-align: left;
  max-width: 90vw;
  overflow-wrap: break-word;
}
</style>
